<template>
  <div class="app-container">
    <!-- 搜索区 -->
    <div ref="topBox">
      <div class="formBox margbot">
        <el-form :inline="true" :model="searchForm" ref="searchForm" class="demo-form" size="mini">
          <el-form-item label="年份:">
            <el-date-picker
              v-model="searchForm.yearDate"
              type="year"
              format="yyyy"
              value-format="yyyy"
              placeholder="请选择"
              :clearable="false"
              style="width:120px">
            </el-date-picker>
          </el-form-item>
          <div style="display: flex; align-items: center;">
            <div class="searchBtnBox">
              <el-form-item>
                <el-button type="primary" class="allBtn" @click="searchFn">查询</el-button>
                <el-button type="primary" class="allBtn" @click="resetForm">重置</el-button>
                <el-button type="primary" class="allBtn" @click="exportFn">导出</el-button>
              </el-form-item>
            </div>
          </div>
        </el-form>
      </div>
    </div>
    <!-- 表格 -->
    <div class="table" :style="{ height: h }">
      <el-table :data="tableList" ref="table" height="100%" class="tableComent" border :row-class-name="rowClassName" v-loading="loading">
        <el-table-column type="index" width="55" label="序号"></el-table-column>
        <el-table-column prop="companyName" label="公司名称" min-width="220" show-overflow-tooltip></el-table-column>
        <el-table-column prop="bankName" label="银行名称" min-width="220" show-overflow-tooltip></el-table-column>
        <el-table-column prop="putDate" label="放款日期" width="120" :formatter="dateFormat"></el-table-column>
        <el-table-column prop="backDate" label="还款日期" width="120" :formatter="dateFormat"></el-table-column>
        <el-table-column prop="loanAmount" label="贷款金额(万元)" width="130" show-overflow-tooltip></el-table-column>
        <el-table-column prop="backAmount" label="还款金额(万元)" width="130" show-overflow-tooltip></el-table-column>
        <el-table-column prop="addAmount" label="本期增加(万元)" width="130" show-overflow-tooltip></el-table-column>
        <el-table-column prop="reduceAmount" label="本期减少(万元)" width="130" show-overflow-tooltip></el-table-column>
        <el-table-column prop="loanBalance" label="贷款余额(万元)" width="130" show-overflow-tooltip></el-table-column>
          <el-table-column prop="count" label="还款笔数" width="90" show-overflow-tooltip></el-table-column>
      </el-table>
    </div>

  </div>
</template>

<script>
import { findInvestmenFinancSituationReport } from '@/api/common-signature'
import { dateFormat } from '@/utils/util'
import { exportExcel } from '@/utils/fileDownXlsx.js'
import global from '@/api/global'

export default {
  name: 'InvFinSituation',
  data () {
    return {
      dateFormat: dateFormat,
      searchForm: {
        yearDate: new Date().getFullYear() + ''
      },
      tableList: [],
      loading: false,
      h: '500px'
    }
  },
  created () {
    this.getList()
  },
  mounted () {
    const topH = this.$refs.topBox ? this.$refs.topBox.offsetHeight : 120
    const pH = document.documentElement.clientHeight
    this.h = (pH - topH - 140) + 'px'
  },
  methods: {
    pickList (res) {
      if (!res) return []
      if (Array.isArray(res)) return res
      if (Array.isArray(res.list)) return res.list
      if (res.data && Array.isArray(res.data.list)) return res.data.list
      if (res.data && Array.isArray(res.data)) return res.data
      return []
    },
    // 合计行由接口返回（列表最后一行），此处仅给最后一行加样式
    rowClassName ({ rowIndex }) {
      if (rowIndex === this.tableList.length - 1) return 'total-row'
      return ''
    },
    getList () {
      this.loading = true
      findInvestmenFinancSituationReport(this.searchForm).then(res => {
        this.loading = false
        this.tableList = this.pickList(res)
      }).catch(err => {
        this.loading = false
        this.$message.error((err && (err.message || err.msg)) || '查询投融资情况失败')
      })
    },
    searchFn () {
      if (!this.searchForm.yearDate) {
        this.$message.warning('请选择年份')
        return
      }
      this.getList()
    },
    resetForm () {
      this.searchForm = {
        yearDate: new Date().getFullYear() + ''
      }
      this.getList()
    },
    exportFn () {
      const url = global.smpName + '/credit/exportInvestmenSituationReport'
      exportExcel(url, { yearDate: this.searchForm.yearDate }, '投融资情况')
    }
  }
}
</script>

<style scoped lang="less">
.searchBtnBox {
  margin-left: 10px;
}
/deep/ .total-row {
  font-weight: bold;
  color: #409EFF;
}
</style>
